const ACTION_UPDATE_POPUP = "updatePopup";
const ACTION_UPDATE_POPUP_FLAG = "updatePopupFlag";
export { ACTION_UPDATE_POPUP, ACTION_UPDATE_POPUP_FLAG };
